import { combineReducers, createStore, applyMiddleware, AnyAction } from 'redux'
import thunk from 'redux-thunk'

import { addBarrierEditorReducer } from './reducers/addBarrierEditorReducer'
import { barrierSelectedToModalReducer } from './reducers/barrierSelectedToModalReducer'
import { bowtieExpandedBarriersReducer } from './reducers/bowtieExpandedBarriersReducer'
import { bowtieLanguageReducer } from './reducers/bowtieLanguageReducer'
import { highlightDegradedBarriersReducer } from './reducers/highlightDegradedBarriersReducer'
import { mandatoryBarrierReducer } from './reducers/mandatoryBarrierReducer'
import { searchBarrierReducer } from './reducers/searchBarrierReducer'

const combineReducersObject = {
    bowtieExpandedBarriers: bowtieExpandedBarriersReducer,
    barrierSelectedToModal: barrierSelectedToModalReducer,
    highlightDegradedBarriers: highlightDegradedBarriersReducer,
    bowtieLanguage: bowtieLanguageReducer,
    searchBarrier: searchBarrierReducer,
    mandatoryBarrier: mandatoryBarrierReducer,
    addBarrierEditor: addBarrierEditorReducer
}

type ReducerObject = typeof combineReducersObject
export type IReduxReducers = { [K in keyof ReducerObject]: Parameters<ReducerObject[K]>[0] }
export type IReduxActions = { [K in keyof ReducerObject]: Parameters<ReducerObject[K]>[1] }

const combinedReducers = combineReducers(combineReducersObject)

const rootReducer = (state: IReduxReducers, action: AnyAction): IReduxReducers => {
    // when a logout action is dispatched it will reset redux state
    if (action.type === 'CLEAR_ALL_STORE') {
        state = undefined
    }

    return combinedReducers(state, action)
}

export const store: any = createStore(rootReducer, applyMiddleware(thunk)) /* {} seria pre loaded state  */

export const clearAllStore = (): void => {
    store.dispatch({ type: 'CLEAR_ALL_STORE' })
}
